import { useEffect, useState } from 'react';

/**
 * Custom hook for parallax scrolling effect
 * Returns offset value based on scroll position
 *
 * @param {number} speed - Parallax speed multiplier (0-1, lower is slower)
 * @returns {number} - Vertical offset in pixels
 */
const useParallax = (speed = 0.5) => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      // Use requestAnimationFrame for smooth performance
      requestAnimationFrame(() => {
        const scrolled = window.pageYOffset;
        setOffset(scrolled * speed);
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [speed]);

  return offset;
};

export default useParallax;
